// Internal modules
import { PHONE_TYPES } from '../constants';

interface ValidatePhoneTypeResult {
  patternMismatch: boolean;
  valueMissing: boolean;
  errors: string[];
  isValid: boolean;
}

type TempErrorsObject = Pick<
  ValidatePhoneTypeResult,
  'patternMismatch' | 'valueMissing'
>;

export const validatePhoneType = (value: string): ValidatePhoneTypeResult => {
  const errorsObject: TempErrorsObject = {
    patternMismatch: Boolean(value.length) && !PHONE_TYPES.includes(value),
    valueMissing: !value.length,
  };

  const errors = (
    Object.keys(errorsObject) as (keyof typeof errorsObject)[]
  ).filter(key => errorsObject[key]);

  return {
    ...errorsObject,
    errors,
    isValid: !errors.length,
  };
};
